import { useState } from 'react';
import Button from './Button.new';
import Tooltip from './new/tooltip';

interface PulseProps {
  tooltip: string;
  isEnabled?: boolean;
  onClose?: () => void;
  size?: 'md' | 'lg';
  showButton?: boolean;
}

export const Pulse = ({ tooltip = '', isEnabled = true, size = 'md', onClose }: PulseProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleClose = () => {
    setIsTooltipOpen(false);
    onClose && onClose();
  };

  if (!isEnabled) return null;

  const pulseSizes = {
    md: '20px',
    lg: '24px',
  };

  return (
    <Tooltip
      isOpen={!!tooltip && isTooltipOpen}
      content={
        !!tooltip && (
          <div className="flex flex-col gap-2">
            <p>{tooltip}</p>
            {!!onClose && <Button onClick={handleClose}>Got it</Button>}
          </div>
        )
      }
    >
      <div
        onMouseEnter={() => {
          if (tooltip) setIsTooltipOpen(true);
        }}
        onMouseLeave={() => setIsTooltipOpen(false)}
        className={`pulse ${!!tooltip && ''}`}
        style={{ ['--pulse-size' as any]: pulseSizes[size] }}
      />
    </Tooltip>
  );
};
